export default __webpack_public_path__ + "static/media/DNo.29-0.ab3a1f64.jpg";